module.exports = __webpack_public_path__ + "static/media/varvaraProduct.9c717acb.jpeg";